module.exports = __webpack_public_path__ + "src/assets/img/start/51a0ee239b4bd6774b16ffdf74b0be41.png";